/**
 * Arabic copy for the Install page.
 *
 * The legacy page ships these strings in English (Locale/Admin/Install.ar.resx was
 * never translated), so the English original is kept next to each entry as the
 * reference for what the screen must still say.
 *
 * `messages` mirrors the responses InstallController returns. Those come from the
 * server, so once Coeia.Rawam.Api is wired up they will arrive in English
 * again unless the endpoints are localized backend-side.
 */
export const strings = {
  // "Installation Setup Page"
  pageTitle: 'صفحة إعداد التثبيت',

  tabs: {
    license: 'بيانات الترخيص', // "License Data"
    dummyData: 'إدراج بيانات تجريبية', // "Dummy Data Insertion"
    topics: 'إضافة مواضيع روام', // "Add Rawam Topics"
    usersPurge: 'حذف المستخدمين', // "Users Purge"
  },

  license: {
    cardTitle: 'بيانات الترخيص', // "License Data"
    fileLabel: 'ملف الترخيص', // "License File"
    fileHint: 'ملف الترخيص الصادر من مركز التميز لأمن المعلومات بصيغة ‎.json',
    apply: 'تطبيق', // "Apply"
  },

  dummyData: {
    // "Generate Users & Groups and doing courses/exam interactions"
    cardTitle: 'إنشاء مستخدمين ومجموعات وتنفيذ تفاعلات الدورات والاختبارات',
    usersCountLabel: 'عدد المستخدمين', // "Users Count"
    action: 'إدراج بيانات وهمية', // "Fake Data Insertion"
  },

  topics: {
    // "Deploy Topics located in Rawam.Content folder ..."
    cardTitle: 'نشر المواضيع الموجودة في مجلد Rawam.Content ...',
    action: 'نشر', // "Deploy"
  },

  usersPurge: {
    // Users.ar.resx -> PageResource1.Title (already Arabic in the legacy app)
    fileLabel: 'قائمة المستخدمين',
    action: 'حذف المستخدمين', // "Users Purge"
  },

  // Users.ar.resx -> WaitScreenLineA
  waitScreen: 'فضلا انتظر ...',
  // Users.ar.resx -> btnClose
  close: 'إغلاق',
  // RawamDemo.sql -> WebsiteFooterText
  footer: 'مركز التميز لأمن المعلومات',

  accessGate: {
    prompt: 'الرجاء إدخال رمز الدخول:', // "Please enter the access code:"
    confirm: 'موافق', // "OK"
    cancel: 'إلغاء', // "Cancel"
    denied: 'تم رفض الوصول أو حدث خطأ في الخادم.', // "Access denied or server error."
  },

  // InstallController responses.
  messages: {
    // "Success"
    success: 'تمت العملية بنجاح',
    // "The files that you have uploaded are not valid!"
    invalidFiles: 'الملفات التي قمت برفعها غير صالحة!',
    // "Only License operation type (new) is allowed in the install section!"
    onlyNewLicense: 'لا يُسمح إلا بنوع عملية الترخيص (new) في قسم التثبيت!',
    // "ERROR:Can not open the provided file, please confirm file name and/or file location"
    cannotOpenFile: 'خطأ: تعذّر فتح الملف المُقدَّم، يرجى التأكد من اسم الملف و/أو موقعه',
    // "ERROR:Provided file is empty!"
    emptyFile: 'خطأ: الملف المُقدَّم فارغ!',
    // "Operation finished successfully..."
    purgeFinished: 'انتهت العملية بنجاح...',
  },

  logoAlt: 'روام',
}
